import React, { useCallback, useMemo, useEffect } from 'react';
import LinkPicker, { type LinkPickerProps } from '@atlaskit/link-picker';
import { ContextualAnalyticsData } from '@atlassian/jira-product-analytics-bridge';
import { Scope, useAtlassianPlugins } from '@atlassian/link-picker-atlassian-plugin';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import customMessages from './messages.tsx';

type Props = {
	onLinkSelected: (link: string) => void;
	onCloseLinkPicker: () => void;
	onMounted?: () => void;
};

const analyticsContextData = {
	componentName: 'aiWorkCreateLinkPicker',
};
export function AiWorkCreateLinkPicker({ onLinkSelected, onCloseLinkPicker, onMounted }: Props) {
	const cloudId = useCloudId();

	const pluginsConf = useMemo(
		() => [
			{
				cloudIds: [cloudId], // get pages across sites user has access to
				products: ['confluence'],
				scope: Scope.ConfluencePageBlog,
			},
		],
		[cloudId],
	);
	const plugins = useAtlassianPlugins(pluginsConf);

	const onLinkPickerSubmit: LinkPickerProps['onSubmit'] = useCallback(
		(payload) => {
			onLinkSelected(payload.url);
			onCloseLinkPicker();
		},
		[onCloseLinkPicker, onLinkSelected],
	);

	useEffect(() => {
		onMounted?.();
	}, [onMounted]);

	return (
		<ContextualAnalyticsData attributes={analyticsContextData}>
			<LinkPicker
				onSubmit={onLinkPickerSubmit}
				onCancel={onCloseLinkPicker}
				plugins={plugins}
				customMessages={customMessages}
				hideDisplayText
			/>
		</ContextualAnalyticsData>
	);
}
